import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';

export interface UpdateCredentialsState extends ApiState {
  updated: boolean,
}

export default requestReducer<UpdateCredentialsState>('UPDATE_CREDENTIALS',
(state, action) => ({ ...state, updated: action.requestStatus === 'FETCH' }))